//this context is for tracking what catalog the user selected and is currently in
import { createContext } from "react";
const CatalogContext = createContext({
	catalogConfig: null,
	setCatalog: () => { },
});
export default CatalogContext;
